import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import BaseComponent from '../BaseComponent';
import Modal from '../Modal';
import Select from '../../components/Select';
import { timeConversion } from '../../utils/date';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const NAME = 'CourtBookingModal';

const SELECTOR_COURT_BOOKING_MODAL = '#js-court-avaibility-booking-modal';
const SELECTOR_COURT_NAME = '.lta-modal-body-subtitle';
const SELECTOR_BOOKING_DATE = '.lta-modal-body__date';
const SELECTOR_START_SELECT = '.p-venue-details__booking-time-select-start .js-lta-select';
const SELECTOR_END_SELECT = '.p-venue-details__booking-time-select-end .js-lta-select';
const SELECTOR_TIMESLOT = '.lta-modal-timeSlot';
const SELECTOR_TIME_LABEL = '.label-totalCost';
const SELECTOR_BOOKING_AMOUNT = '.p-venue-details__booking-modal-price-amount';
const SELECTOR_CHECKOUT_BUTTON = '.lta-modal-bookCourt__form-btn';
const SELECTOR_CANCEL_BUTTON = '.lta-modal-bookCourt__form-btn-cancel';
const SELECTOR_ERROR_LABEL = '.lta-modal-timeSlot__error';
const SELECTOR_CLOSE = '.lta-modal-close';

const CLICK_EVENT = 'click';
const CHANGE_EVENT = 'change';

const START_TIME_ERROR = 'Start time does not meet the minimum time slot, please try selecting a later time.';
const END_TIME_ERROR = 'End time does not meet the minimum time slot, please try selecting a later time.';

const DATE_FORMAT = 'dddd, Do MMMM YYYY';

class CourtBookingModal extends BaseComponent {
	constructor(element) {
		super(element);
		if (this._element) {
			this._mainSelector = element;
			this._checkoutCallbacks = [];
			this.init();
		}
	}

	static get NAME() {
		return NAME;
	}

	get slotsData() {
		return this._slotsData;
	}

	set slotsData(data) {
		this._slotsData = [];
		this._slotsData = data;
		this.updateStartEndData(this._slotsData);
	}

	updateStartEndData(filterData) {
		this.startTimeData = [...new Set(filterData.map((slot) => slot.startTime))];
		this.endTimeData = [...new Set(filterData.map((slot) => slot.endTime))];
	}

	filterTimeSlots(isFromModal) {
		const filteredData = this.slotsData.filter((slot) => {
			if (this.selectedSlot) {
				if (this.selectedSlot.startTime && this.selectedSlot.startTime !== slot.startTime) {
					return false;
				}

				if (this.selectedSlot.endTime && this.selectedSlot.endTime !== slot.endTime) {
					return false;
				}
			}
			return true;
		});
		this.selectedData = filteredData;
		if (isFromModal && filteredData.length === 0) {
			this.updateStartEndData(this.slotsData);
		} else {
			this.updateStartEndData(filteredData);
		}
		this.updateStartTimeSlots();
		this.updateEndTimeSlots();
	}

	init() {
		if (!this._mainSelector) {
			return;
		}
		this.courtBookingModalSelector = SelectorEngine.findOne(SELECTOR_COURT_BOOKING_MODAL, this._mainSelector);
		this.courtBookingModal = new Modal(this.courtBookingModalSelector, { backdrop: 'static' });

		this.bookingCourtName = SelectorEngine.findOne(SELECTOR_COURT_NAME, this.courtBookingModalSelector);
		this.courtBookingDate = SelectorEngine.findOne(SELECTOR_BOOKING_DATE, this.courtBookingModalSelector);

		this.startTime = SelectorEngine.findOne(SELECTOR_START_SELECT, this.courtBookingModalSelector);
		this.startTimeSlotElement = Select.getInstance(this.startTime) || new Select(this.startTime);

		this.endTime = SelectorEngine.findOne(SELECTOR_END_SELECT, this.courtBookingModalSelector);
		this.endTimeSlotElement = Select.getInstance(this.endTime) || new Select(this.endTime);

		this.timeSlotElement = SelectorEngine.findOne(SELECTOR_TIMESLOT, this.courtBookingModalSelector);
		this.totalCost = SelectorEngine.findOne(SELECTOR_TIME_LABEL, this.courtBookingModalSelector);
		this.bookingAmount = SelectorEngine.findOne(SELECTOR_BOOKING_AMOUNT, this.courtBookingModalSelector);
		this.cancelButton = SelectorEngine.findOne(SELECTOR_CANCEL_BUTTON, this.courtBookingModalSelector);
		this.lableError = SelectorEngine.findOne(SELECTOR_ERROR_LABEL, this.courtBookingModalSelector);
		this.closeButton = SelectorEngine.findOne(SELECTOR_CLOSE, this.courtBookingModalSelector);
		this.checkoutButton = SelectorEngine.findOne(SELECTOR_CHECKOUT_BUTTON, this.courtBookingModalSelector);

		EventHandler.on(
			this.startTimeSlotElement._selectNativeElement,
			CHANGE_EVENT,
			this.startTimeSlotChangeHandler.bind(this)
		);
		EventHandler.on(
			this.endTimeSlotElement._selectNativeElement,
			CHANGE_EVENT,
			this.endTimeSlotChangeHandler.bind(this)
		);
		EventHandler.on(this.cancelButton, CLICK_EVENT, this.onCancelClickHandler.bind(this));
		EventHandler.on(this.closeButton, CLICK_EVENT, this.onCancelClickHandler.bind(this));
		EventHandler.on(this.checkoutButton, CLICK_EVENT, this.onCheckOutClickHandler.bind(this));
	}

	onCheckOutClickHandler() {
		if (
			this.selectedData.length > 0 &&
			this.selectedSlot &&
			this.selectedSlot.startTime !== '' &&
			this.selectedSlot.endTime !== ''
		) {
			const requestObject = {
				bookingToken: window.bookingToken,
				courtName: this.selectedData[0].court.name
			};
			requestObject.slots = this.selectedData[0].slots;
			startLoadingAnimation();
			this.closeModal();
			this.executeCheckoutSuccessHandler(requestObject);
		} else {
			if (this.selectedSlot.startTime === '' || this.selectedSlot.endTime === '') {
				this.timeSlotElement.classList.add(ClassNames.Invalid);
				if (this.selectedSlot.startTime === '') {
					this.startTimeSlotElement._selectedElement.classList.add(ClassNames.Error);
					this.isError(START_TIME_ERROR);
				}

				if (this.selectedSlot.endTime === '') {
					this.endTimeSlotElement._selectedElement.classList.add(ClassNames.Error);
					this.isError(END_TIME_ERROR);
				}
			}
		}
	}

	executeCheckoutSuccessHandler(requestObject) {
		for (const callback of this._checkoutCallbacks) {
			callback(requestObject);
		}
		stopLoadingAnimation();
	}
	onCheckout(callback) {
		this._checkoutCallbacks.push(callback);
	}

	onCancelClickHandler() {
		this.closeModal();
	}

	startTimeSlotChangeHandler() {
		this.selectedSlot.startTime = this.startTimeSlotElement._selectNativeElement.value;
		this.filterTimeSlots(false);
		this.checkStartEndTimeError();
		if (this.checkAvaibilitySlot()) {
			this.renderPrice();
		}
	}
	endTimeSlotChangeHandler() {
		this.selectedSlot.endTime = this.endTimeSlotElement._selectNativeElement.value;
		this.filterTimeSlots(false);
		this.checkStartEndTimeError();
		if (this.checkAvaibilitySlot()) {
			this.renderPrice();
		}
	}

	checkStartEndTimeError() {
		if (this.selectedSlot.startTime !== '' || this.selectedSlot.endTime !== '') {
			this.totalCost.classList.add(ClassNames.Hidden);
			this.isNotError();
		}
	}

	isError(errorMessage) {
		this.lableError.classList.remove(ClassNames.Hidden);
		this.lableError.innerHTML = errorMessage;
	}

	isNotError() {
		this.timeSlotElement.classList.remove(ClassNames.Invalid);
		this.startTimeSlotElement._selectedElement.classList.remove(ClassNames.Error);
		this.endTimeSlotElement._selectedElement.classList.remove(ClassNames.Error);
		this.lableError.classList.add(ClassNames.Hidden);
	}

	async dateFormatSet(dateString) {
		const dayjs = await import('dayjs');
		this.courtBookingDate.innerHTML = dayjs.default(new Date(dateString)).format(DATE_FORMAT);
	}

	openModal(courtData, selectedSlot) {
		const courtName = `${courtData.name} - ${courtData.type} ${courtData.surface} court`;
		this.bookingCourtName.innerHTML = courtName;

		this.dateFormatSet(courtData?.availableSlots[0].startTime);
		const foundSlot = this.slotsData.find((slot) => slot.startTime === selectedSlot.startTime);

		this.selectedSlot = {
			...selectedSlot,
			endTime: foundSlot?.endTime
		};

		if (!foundSlot) {
			this.selectedSlot.startTime = '';
			this.selectedSlot.endTime = '';
		}

		this.filterTimeSlots(true);
		this.renderPrice();
		this.courtBookingModal.show();
	}

	checkAvaibilitySlot() {
		const startTime = this.selectedSlot.startTime;
		const endTime = this.selectedSlot.endTime;
		return this.slotsData.some((slot) => slot.startTime === startTime && slot.endTime === endTime);
	}

	renderPrice() {
		const startTime = this.selectedSlot.startTime;
		const endTime = this.selectedSlot.endTime;

		const filterData = this.slotsData.find((slot) => slot.startTime === startTime && slot.endTime === endTime);
		if (filterData) {
			this.totalCost.classList.remove(ClassNames.Hidden);
			const bookingString = filterData.slots.reduce((previousValue, nextValue) => previousValue + nextValue.price, 0);
			this.bookingAmount.innerHTML = `£${Number.parseFloat(bookingString).toFixed(2)}`;
			this.isNotError();
		}
	}

	closeModal() {
		this.selectedSlot = {};
		this.selectedData = [];
		this.slotsData = [];
		this.isNotError();
		this.courtBookingModal.hide();
	}

	formatAMPM(date) {
		let hours = date.getHours();
		let minutes = date.getMinutes();
		const ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		const stringTime = hours + ':' + minutes + ' ' + ampm;
		return stringTime;
	}

	getHoursMinutesFormat(dateValue) {
		const selectedDate = new Date(dateValue);
		let hours = selectedDate.getHours();
		let minutes = selectedDate.getMinutes();
		hours = hours < 10 ? '0' + hours : hours;
		minutes = minutes < 10 ? '0' + minutes : minutes;
		return `${hours}:${minutes}`;
	}

	updateStartTimeSlots() {
		this.startTimeSlotElement.clearItems();
		const element = SelectorEngine.findOne('select', this.startTimeSlotElement._element);
		const options = [
			`<option value="" disabled="" hidden="" selected> Please Select</option>`,
			...Object.keys(this.startTimeData)
				.sort((object1, object2) => new Date(this.startTimeData[object1]) - new Date(this.startTimeData[object2]))
				.map(
					(index) =>
						`<option value="${this.startTimeData[index]}" ${
							this.startTimeData[index] === this.selectedSlot.startTime ? 'selected' : ``
						}>
						${timeConversion(this.startTimeData[index])}
					</option>`
				)
		].join('');
		element.innerHTML = options;
		this.startTimeSlotElement.generateItems();
	}

	updateEndTimeSlots() {
		this.endTimeSlotElement.clearItems();
		const element = SelectorEngine.findOne('select', this.endTimeSlotElement._element);
		const options = [
			`<option value="" disabled="" hidden="" selected> Please Select</option>`,
			...Object.keys(this.endTimeData)
				.sort((object1, object2) => new Date(this.endTimeData[object1]) - new Date(this.endTimeData[object2]))
				.map(
					(index) =>
						`<option value="${this.endTimeData[index]}" ${
							this.endTimeData[index] === this.selectedSlot.endTime ? 'selected' : ``
						}>
						${timeConversion(this.endTimeData[index])}
					</option>`
				)
		].join('');
		element.innerHTML = options;
		this.endTimeSlotElement.generateItems();
	}
}
export default CourtBookingModal;
